/* eslint-disable no-shadow */
/* eslint-disable default-case */
/* eslint-disable no-unused-vars */
/* eslint-disable no-loop-func */
/* eslint-disable no-plusplus */
/* eslint-disable no-undef */
/* eslint-disable indent */
function hexToBuffer(hexString) {
    const ints = [];
    for (let i = 0; i < hexString.length; i += 2) {
        ints.push(parseInt(hexString.slice(i, i + 2), 16));
    }
    return (new Uint8Array(ints)).buffer;
}

function decrypt(data, keyHex, ivHex) {
    const keyBytes = hexToBuffer(keyHex);
    const ivBytes = hexToBuffer(ivHex);
    const dataBytes = hexToBuffer(data);
    let key = null;

    const returnVal = window.crypto.subtle.importKey('raw', keyBytes, 'AES-GCM', true, ['encrypt', 'decrypt']);
    const decryptKey = function (_key) {
        key = _key;
        return window.crypto.subtle.decrypt({ name: 'AES-GCM', iv: ivBytes }, key, dataBytes);
    };

    returnVal
        .then(decryptKey)
        .then((decrypted) => String.fromCharCode.apply(null, new Uint8Array(decrypted)))
        .catch((e) => {
            console.error('Decryption error:');
            console.error(e);
        });

    return returnVal;
}

function hlsInit(videoElement, videoURL, key = '') {
    const hlsOpts = {};
    let hls = null;
    let switched = false;
    // eslint-disable-next-line no-undef

    const switchSource = (url) => {
        if (!switched) {
            videoElement.classList.add('video-loading');
            switched = true;
            videoElement.src = url;
            videoElement.addEventListener('loadeddata', () => {
                videoElement.classList.remove('video-loading');
            });
            videoElement.load();
            videoElement.play();
            if (hls) {
                hls.stopLoad();
            }
        }
    };

    hlsOpts.xhrSetup = (xhr, url) => {
        if (url.match(/key.bin$/)) {
            if (key) {
                xhr.setRequestHeader('X-DRM-SESSION', key);
            }
        } else if (url.match(/\.m3u8$/i)) {
            xhr.addEventListener('load', (e) => {
                if (!switched && xhr.responseURL && xhr.responseURL.match(/\.mp4$/i)) {
                    switchSource(xhr.responseURL);
                }
            });
        }
    };

    hls = new Hls(hlsOpts);
    hls.on(Hls.Events.ERROR, (event, err) => {
        if (err.error.message.match(/MediaSource/)) {
            // No media source extensions - maybe iOS? Fall back to native playback
            switchSource(videoURL);
        }
    });
    hls.loadSource(videoURL);
    hls.attachMedia(videoElement);
}

document.addEventListener('DOMContentLoaded', (event) => {
    const element = document.querySelector('video');
    const playButton = document.querySelector('.video-overlay-play-button');
    const hidePlayButtonOverlay = function () {
        // hide the overlay play button
        playButton.classList.add('hidden');
        // add the controls
        element.setAttribute('controls', 'controls');
    };

    let videoPath = '';

    let videoURL = '';
    let keyPath = null;
    let secureKey = '';

    for (let i = element.attributes.length - 1; i >= 0; i--) {
        if (element.attributes[i].name.match(/^data-/i)) {
            switch (element.attributes[i].name) {
                case 'data-video-path':
                    videoPath = element.attributes[i].value;
                    break;
                case 'data-video-url':
                    videoURL = element.attributes[i].value;
                    break;
                case 'data-key-path':
                    keyPath = element.attributes[i].value;
                    break;
                case 'data-secure-key':
                    secureKey = element.attributes[i].value;
                    break;
            }
        }
    }

    if (videoPath) {
        if (videoPath.substr(-1, 1) === '/') {
            // Trim trailing /
            videoPath = videoPath.substr(0, videoPath.length - 1);
        }

        // Auto-select HLS when available
        if (element.canPlayType('application/vnd.apple.mpegURL')) {
            // videoURL = `${videoPath}/master.m3u8`;
            // apple/safari has it's own play button overlay
            hidePlayButtonOverlay();
        }

        // force HLS
        videoURL = `${videoPath}/master.m3u8`;
    }

    let loaded = false;
    let playStarted = false;
    const loadVideo = function (event) {
        // hide the play button overlay
        hidePlayButtonOverlay();

        if (loaded) return;
        loaded = true;
        hlsInit(element, videoURL, secureKey);

        if (event instanceof MouseEvent) {
            // The loadVideo call was not fired by a Video event. Attempt to-autoplay
            element.addEventListener('canplay', (event) => {
                if (!playStarted) {
                    element.play();
                    playStarted = true;
                }
            });
        }
    };

    element.addEventListener('playing', (event) => {
        playStarted = true;
    });

    // Listen for events before loading the video to save CDN bandwidth
    playButton.addEventListener('click', loadVideo);
    element.addEventListener('play', loadVideo);
    element.addEventListener('click', loadVideo);
    element.addEventListener('mousedown', loadVideo);
});
